import React, {useEffect, useState} from "react";
import Cookies from "js-cookie";
import {Box, Button, Link, makeStyles, Portal, Typography} from "@material-ui/core";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        maxWidth: 600,
        position: "fixed",
        bottom: 0,
        left: 0,
        margin: theme.spacing(3),
        padding: theme.spacing(3),
        outline: "none",
        zIndex: 2000
    },
    action: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.black
    }
}));

const CookiesNotification = () => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const {t} = useTranslation("notifications");

    const handleClose = () => {
        Cookies.set("consent", "true");
        setOpen(false);
    };

    useEffect(() => {
        const consent = Cookies.get("consent");

        if (!consent) {
            setOpen(true);
        }
    }, []);

    if (!open) {
        return null;
    }

    return (
        <Portal>
            <div className={classes.root}>
                <Typography variant="body1" color="inherit">
                    {t("cookie.alert")} {t("cookie.privacyPolicy.prefix")}{" "}
                    <Link component="a" color="inherit" underline="always" href={t("cookie.privacyPolicy.link")} target="_blank">
                        {t("cookie.privacyPolicy.name")}
                    </Link>
                </Typography>

                <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button onClick={handleClose} variant="contained" className={classes.action}>
                        {t("cookie.cta")}
                    </Button>
                </Box>
            </div>
        </Portal>
    );
};

export default CookiesNotification;
